export default __webpack_public_path__ + "db3cb0c5047a9de8f8710b4758c910e1.png";